import { SET_DRUG_LABEL_LIST } from '../constants/DrugLabel';

export const setDrugLabelList = (drugLabelList) => {
  console.log('action setDrugLabelList');
  return {
    type: SET_DRUG_LABEL_LIST,
    drugLabelList
  };
};
